// extracted by mini-css-extract-plugin
export default {"product-info-section":"WdljtPSxR_jXY8caY9kT","section-title":"S1FxXlEB4_4Lh57EW6XQ","divider-wrapper":"SJ0YX5ES4MR1LMqnWvE4"};